<template>
  <ListLayout
    :gridStyle="
      apiTokenKey && showTokenKey
        ? { height: 'calc(100vh - 420px)' }
        : { height: 'calc(100vh - 350px)' }
    "
    :title="`${configurationModule.apiTokenPlural}`"
    :tableData="apiTokenList"
    :tableHeader="tableHeaders"
    :total="totalItems"
    :context="context"
    @getList="getApiTokenList"
  >
    <template #listAction>
      <!-- <v-tooltip bottom :color="isButtonDisabled ? 'error' : ''">
        <template v-slot:activator="{ on: tooltip }">
          <div v-on="{ ...tooltip }"> -->
              <!-- v-if="permissions && permissions.add" -->
            <PrimaryButton
              id="apiTokenAdd"
              :disabled="isButtonDisabled || apiTokenList.length == 1"
              @click="addApiToken"
              :name="`Add ${configurationModule.apiTokenPlural}`"
              icon="mdi-plus"
              iconSize="x-large"
            >
            </PrimaryButton>
          <!-- </div>
        </template>
        <span>{{ buttonTooltip }}</span>
      </v-tooltip> -->
    </template>

    <template #alertInfo>
      <v-alert
        v-if="apiTokenKey && showTokenKey"
        type="success"
        dense
        prominent
        class="mx-4 mt-3"
      >
        <span>
          New Api Key created and <b>it will be display only now.</b>
        </span>
        <v-chip label color="success lighten-1" class="ml-6">
          {{ apiTokenKey.key }}
          <CopyToClipboard :textTobeCopied="apiTokenKey.key" iconClass="ml-2" />
        </v-chip>
        <p class="mb-0">
          Please store it somewhere safe because as soon as you navigate away
          from this page, we will not be able to retrieve or restore this
          generated token.
        </p>
      </v-alert>
    </template>

    <template #dialogs>
      <ApiTokenForm
        v-model="showApiTokenForm"
        @refreshList="getApiTokenList"
        @apiTokenKey="showApiTokenKey"
      />
    </template>
  </ListLayout>
</template>

<script>
import { bus } from "@/main.js";
import ListLayout from "@/components/LayoutComponents/ListLayout.vue";
import apiTokenButton from "@/components/Button/apiTokenButton.vue";
import ApiTokenForm from "@/components/ModuleBasedComponents/ApiToken/ApiTokenForm.vue";
import CopyToClipboard from "@/components/GeneralComponents/CopyToClipboard.vue";
import { configurationModule } from "@/utils/moduleMapping";
export default {
  components: { ListLayout, apiTokenButton, ApiTokenForm, CopyToClipboard },
  data() {
    return {
      configurationModule,
      totalItems: 0,
      filters: {},
      apiTokenList: [],
      headerSelected: [
        {
          headerName: "Name",
          field: "name",
          sortable: true,
        },
        {
          headerName: "Prefix",
          field: "prefix",
          sortable: false,
        },
        {
          headerName: "Created",
          field: "created",
          sortable: false,
        },
      ],

      apiTokenKey: {},
      showTokenKey: false,

      showApiTokenForm: false,

      isButtonDisabled: false,
      buttonTooltip: "Add Api Token",
    };
  },
  computed: {
    context() {
      return { parentComponent: this };
    },
    tableHeaders() {
      return [
        ...this.headerSelected,
        {
          headerName: "Actions",
          field: "actions",
          pinned: "right",
          minWidth: 120,
          sortable: false,
          width: 120,
          cellRenderer: "apiTokenButton",
        },
      ];
    },
    profileObject() {
      let obj = localStorage.getItem("user_data");
      return obj ? JSON.parse(obj) : null;
    },
  },
  methods: {
    addApiToken() {
      this.showApiTokenForm = true;
    },
    showApiTokenKey(data) {
      this.showTokenKey = true;
      this.apiTokenKey = data;
    },
    regenerateApiToken() {
      bus.$emit("showLoader", true);
      this.$api.apiToken
        .regenerateApiTokenObject()
        .then((res) => {
          bus.$emit("showLoader", false);
          bus.$emit("showToastMessage", {
            message: "Api Token successfully regenerate",
            color: "success",
          });
          this.showTokenKey = true;
          this.apiTokenKey = { ...res.data };
        })
        .catch((err) => {
          bus.$emit("showLoader", false);
          console.error(err);
        });
    },

    // checkSubscriptionLimit() {
    //   this.$api.company
    //     .checkSubscriptionLimit(this.profileObject.company, {
    //       module: "branch",
    //     })
    //     .then(() => {
    //       this.isButtonDisabled = false;
    //       return true;
    //     })
    //     .catch((err) => {
    //       bus.$emit("showToastMessage", {
    //         message: err.data.non_field_errors[0],
    //         color: "error",
    //         timeout: 4000,
    //       });
    //       this.isButtonDisabled = true;
    //       this.buttonTooltip = err.data.non_field_errors[0];
    //       return false;
    //     });
    // },

    getApiTokenList(params = {}) {
      bus.$emit("showLoader", true);
      params = {
        ...params,
        ...this.filters,
      };

      if ("ordering" in params && params.ordering.length > 0) {
        params = { ...params, ordering: params.ordering.join(",") };
      }

      this.$api.apiToken
        .getApiTokenList(params)
        .then((res) => {
          bus.$emit("showLoader", false);
          this.apiTokenList = res.data;
          this.totalItems = res.count;
        })
        .catch((err) => {
          bus.$emit("showLoader", false);
          console.log(err);
        });
    },
  },
  // created() {
  //   this.permissions = this.$permissions.getPermission("configuration");

  //   this.checkSubscriptionLimit();
  // },
};
</script>
